module.exports = __webpack_public_path__ + "static/media/hu.fd87f88e.svg";